import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import { Card, CardBody } from "reactstrap";
import "./styled.css";

// services
import { postSurvey } from "../../../services/survey";
import { createEarnedPoints } from "../../../services/ranking";
// componentes
import Question1 from "./question1";
import Question2 from "./question2";
import Question3 from "./question3";
import Question4 from "./question4";
import Question5 from "./question5";
import Question6 from "./question6";
import Question7 from "./question7";
import Question8 from "./question8";
import Question9 from "./question9";
import FinalModal from "./finalModal";

export default function StefaniniEnquete1Questions(props) {
  const { t } = useContext(QuizContext);
  const { user } = props;
  // todas as questões selecionadas
  const [questionsSelected, setQuestionSelected] = useState({});
  // verificar respostas
  const [checkAnswers, setCheckAnswers] = useState(false);
  // modal de finalização
  const [modal, setModal] = useState(false);
  // erro
  const [erro, setErro] = useState(false);
  // carregando btn
  const [loading, setLoading] = useState(false);

  async function verifyAnswers() {
    setLoading(true);
    // verificar se todas foram respondidas
    if (!questionsSelected.question6 || !questionsSelected.question7) {
      setErro(true);
      setLoading(false);
      return;
    } else setErro(false);

    // enviar dados para api
    if (user.idEvent && user.idPart) {
      const data6 = {
        eventId: user.idEvent,
        loginId: user.idPart,
        question: questionsSelected.question6.title,
        answer: questionsSelected.question6.option,
        hit: questionsSelected.question6.correct,
      };

      await postSurvey(data6).then((res) => {
        if (res.message === "created" && questionsSelected.question6.correct) {
          const dataRanking6 = {
            code: "MARKETINGPERGUNTA1",
            positive: true,
            log: "Acertou enquete",
          };

          createEarnedPoints(dataRanking6, user.idEvent, user.idPart);
        }
      });

      const data7 = {
        eventId: user.idEvent,
        loginId: user.idPart,
        question: questionsSelected.question7.title,
        answer: questionsSelected.question7.option,
        hit: questionsSelected.question7.correct,
      };

      await postSurvey(data7).then((res) => {
        if (res.message === "created" && questionsSelected.question7.correct) {
          const dataRanking7 = {
            code: "T&DPERGUNTA1",
            positive: true,
            log: "Acertou enquete",
          };

          createEarnedPoints(dataRanking7, user.idEvent, user.idPart);
        }
      });
    }

    setLoading(false);

    setCheckAnswers(true);

    setModal(true);
  }
  return (
    <section className="section-boe">
      {modal && (
        <FinalModal
          isOpen={modal}
          toggle={() => setModal(!modal)}
          questions={questionsSelected}
        />
      )}

      <Card className="card-boe">
        <CardBody>
          {/* <h1
            className="title-section-boefanini"
            style={{ marginTop: 0, marginBottom: 10, borderTop: "none" }}
          >
            MARKETING DIGITAL
          </h1> */}
          <Question6
            setQuestionSelected={setQuestionSelected}
            checkAnswers={checkAnswers}
          />

          {/* <h1 className="title-section-boefanini">T&D</h1> */}
          <Question7
            setQuestionSelected={setQuestionSelected}
            checkAnswers={checkAnswers}
          />

          {erro && (
            <div style={{ textAlign: "center" }}>
              <a style={{ color: "red", fontSize: 17 }}>
                {t("Responda todas perguntas")}
              </a>
            </div>
          )}

          <a
            className={`${checkAnswers ? "btn-submit-disabled" : "btn-submit"}`}
            onClick={() => {
              if (!checkAnswers && !loading) {
                verifyAnswers();
              }
            }}
          >
            {t("Salvar respostas")}
          </a>
        </CardBody>
      </Card>
    </section>
  );
}
